import { UploadSimpleIcon } from "@phosphor-icons/react/dist/csr/UploadSimple";
import { Link } from "react-router-dom";
import { Button } from "@volca/ui/components/ui/button";
import { cn } from "@volca/ui/lib/utils";
import { inputTitle, useReportInputs } from "@/profitability/missing-value";
import { shortPeriod } from "@/profitability/new-run/run-period";
import { profitabilityNewRunPath } from "@/profitability/routes";
import type { ReportDates } from "@/profitability/types";

/**
 * Where a missing figure is filled: the upload page for its period, the
 * dates set, the input it comes from marked and the period's other files
 * kept. "Upload Payroll export" when the input is known, else "Add files
 * for Oct 12–18". Only for someone who may run the template.
 */
export const UploadInputButton = ({
  reportId,
  source,
  dates,
  runId,
  variant = "default",
  className,
}: {
  reportId: string;
  /** The input (slot key) to upload; null when the gaps name none, or several. */
  source: string | null | undefined;
  /** The period to fill; null opens the upload page without one. */
  dates: ReportDates | null;
  /** The run whose other files to keep. */
  runId?: string | null;
  variant?: "default" | "outline";
  className?: string;
}) => {
  const input = inputTitle(useReportInputs(), source);
  const when = dates ? shortPeriod(dates) : null;
  return (
    <Button
      size="sm"
      variant={variant}
      // Inside an alert, which underlines its links; this one is a button.
      className={cn("no-underline!", className)}
      nativeButton={false}
      render={
        <Link
          to={profitabilityNewRunPath(
            reportId,
            dates && {
              ...dates,
              input: input ? source : null,
              from: runId,
            },
          )}
        />
      }
    >
      <UploadSimpleIcon aria-hidden data-icon="inline-start" />
      {input ? `Upload ${input}` : when ? `Add files for ${when}` : "Add files"}
    </Button>
  );
};
